import { AppAuthError, BaseTokenRequestHandler, TokenError, TokenResponse } from '@openid/appauth';
import { params, isBlank } from '../commons';

class SpacesTokenRequestHandler extends BaseTokenRequestHandler {
  performTokenRequest = (configuration, request) => {
    if (isBlank(params.oauth2ClientId())) {
      throw new Error(
        'Could not perform token request because of missing client id or client secret'
      );
    }

    const tokenResponse = this.requestor.xhr({
      url: configuration.tokenEndpoint,
      method: 'POST',
      dataType: 'json',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      data: this.utils.stringify(request.toStringMap()),
    });

    return tokenResponse.then(response => {
      if (!response.error) {
        return new TokenResponse(response);
      }
      return Promise.reject(new AppAuthError(response.error, new TokenError(response)));
    });
  };
}

export default SpacesTokenRequestHandler;
